import React, { } from "react";
import Layout from "../../comman/Layout/Layout";
import { Segment, Header, Table, Icon, Grid, List, Search, Card, Modal, Button, Pagination, Form, Checkbox } from "semantic-ui-react";
import { Select } from "@material-ui/core";
import { Constants } from '../../../src/config/appConstants';
import './projects.css';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import NoResultFound from "../sharedComponent/noResultFound";
import InfinteScroll from "react-infinite-scroll-component";

const ProjectsComponent = props => {

    return (
        <Layout>
            <Segment className="header-section">
                <Header as="h3">
                    <Icon name="file alternate outline"></Icon>
                    <span>Projects</span>
                </Header>
                <div style={{ display: 'flex', color: '#2196F3', alignItems: 'center' }}>
                    <h4 style={{ margin: '0' }}>Status:</h4>
                    <Select value={props.project.selectedStatus} onChange={props.handleChange}>
                        {props.renderOptions()}
                    </Select>
                </div>
            </Segment>
            <Table className="ui celled table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                        <Table.HeaderCell className="text-left">
                            Project Number - Name
                            <Search className="theader" onSearchChange={props.onProjectSearch} value={props.project.searchProjectText}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                        <Table.HeaderCell className="text-left">Task Codes
                            <Search className="theader" onSearchChange={props.onProjectTaskSearch} value={props.project.searchTaskText}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                        <Table.HeaderCell className="text-left">Devices
                            <Search className="theader" onSearchChange={props.onProjectDeviceSearch} value={props.project.searchDeviceText}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.project.filterProjectData && props.project.filterProjectData.length > 0 || props.project.selectedProjectTasks && props.project.selectedProjectTasks.length > 0 || props.project.projectBasedAssignedDevices && props.project.projectBasedAssignedDevices.length > 0 ?
                        <Table.Row style={{ verticalAlign: 'top' }}>
                            <Table.Cell className="tableCell">
                                <List selection>
                                    {props.project.filterProjectData && props.project.filterProjectData.map(({ isSelected, projectNumber, projectName, id

                                    }) => (

                                        <div key={id} className={(props.user.roleName === Constants.READ_ONLY || props.project.selectedStatus.toLowerCase() === Constants.STATUS_INACTIVE) ? "iconsEmployeePage" : "iconsPage"}>

                                            {props.user.claimValue.includes(Constants.BUTTON_CLAIMS.PROJECT_EDIT_BUTTON) && props.project.selectedStatus === Constants.PROJECT_STATUS_ACTIVE &&
                                                <img className="imageSize" src={require('../../assets/images/editIcon.png')} onClick={() => {
                                                    props.selectedProject(id, projectNumber, true);
                                                }} />}
                                            <Icon className="myiconstyle" name='pencil'
                                                onClick={() => {
                                                    props.viewProjectDetail({ modalOpen: true, projectId: id, projectNumber: projectNumber });
                                                }}
                                            />
                                        </div>
                                    ))}
                                </List>
                            </Table.Cell>
                            <Table.Cell>
                                <List selection animated style={{ display: 'grid' }}>
                                    {props.project.filterProjectData && props.project.filterProjectData.length > 0 ? props.project.filterProjectData.map(({ isSelected, projectNumber, projectName, id }) => (
                                        <List.Item key={id} active={isSelected}>
                                            <div className={isSelected ? "listDescriptionBold" : "listDescription"}
                                                onClick={() => {
                                                    props.selectedProject(id, projectNumber);
                                                }}>
                                                {projectNumber} - {projectName}
                                            </div>
                                        </List.Item>
                                    )) : <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />}
                                </List>

                            </Table.Cell>
                            <Table.Cell>
                                <List className="gridRowHeight">
                                    {props.project.selectedProjectTasks && props.project.selectedProjectTasks.length > 0 ? props.project.selectedProjectTasks.map(({ taskName, taskNumber }) => (
                                        <div key={`${taskNumber}-${taskName}`} className="ptb5">
                                            {taskNumber}-{taskName}
                                        </div>
                                    )) : <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />}
                                </List>
                            </Table.Cell>
                            <Table.Cell>
                                <List className="gridRowHeight">
                                    {props.project.projectBasedAssignedDevices && props.project.projectBasedAssignedDevices.length > 0 ? props.project.projectBasedAssignedDevices.map(({ deviceEmpID },index) => (
                                        <div key={`${deviceEmpID}-${index}`} className="ptb5 columnWidth">
                                            {deviceEmpID}
                                        </div>
                                    )) : <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />}
                                </List>
                            </Table.Cell>
                        </Table.Row> :
                        <Table.Row style={{ width: '100%' }}>
                            <Table.Cell colSpan="4">
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>
            <Modal closeIcon
                open={props.project.isOpenAssignmentModal}
                closeOnDimmerClick={false}
                onClose={() => props.editAssignDevices({ modalOpen: false })}
            >
                <Modal.Header className="headerColor text-color">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={7}>
                                Assign Project To Devices
                            </Grid.Column>
                            <Grid.Column width={2}>

                            </Grid.Column>
                            <Grid.Column width={7}>
                                <span className="employeeDetail">{props.project.selectedProjects ? props.project.selectedProjects.projectNumber : ""}</span>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>
                <Modal.Content scrolling>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={7}>
                                <Header className="headerColor text-color">Unassigned Devices</Header>

                                <Grid.Column width={6} className="gridColoumn">
                                    <Search className="searchWidth" onSearchChange={props.onUnAssignDeviceSearch} placeholder={Constants.SEARCH_PLACEHOLDER} />
                                </Grid.Column>
                                <Grid celled>
                                    <Grid.Row>
                                        <Grid.Column className="columnHeight stickyData d-flex-imp flex-column-imp">
                                            <Checkbox className="checkbox-override stickyHeader" checked={props.project.isSelectAllUnAssignedProjectDevice} name='selectAll' label='Select All' onChange={(e, value) => props.handleChkBoxChgForUnassignedDevices(e, { value })} />
                                            {props.project.isSelectAllUnAssignedProjectDevice ?
                                                <div id="unAssignedProjectDeviceSelectAll"
                                                    style={{
                                                        height: '300px',
                                                        overflow: props?.project?.unAssignedProjectDeviceInfiniteList?.length > 0 ? 'auto' : 'hidden'
                                                    }}
                                                >
                                                    <InfinteScroll style={{ height: '100%', overflow: 'initial' }}
                                                        dataLength={props?.project?.unAssignedProjectDeviceInfiniteList?.length}
                                                        hasMore={true}
                                                        next={() => props.fetchNext("UNASSIGN_DEVICE")}
                                                        scrollableTarget="unAssignedProjectDeviceSelectAll"
                                                    >
                                                        <List selection animated verticalAlign='middle'>
                                                            {props?.project?.unAssignedProjectDeviceInfiniteList?.length > 0 ? props?.project?.unAssignedProjectDeviceInfiniteList?.map(({ deviceEmpID, deviceID, isSelected, isCheckedChckBox }) => (
                                                                <List.Item key={deviceID} active={isSelected}>
                                                                    <List.Content textAlign="center">
                                                                        <List.Description className={isSelected ? "listDescriptionBold" : "listDescription"}
                                                                            onClick={() => {
                                                                                props.assignDeviceToProjects({ deviceID: deviceID });
                                                                            }}><Checkbox checked={isCheckedChckBox} label={deviceEmpID} onChange={(e, value) => props.handleChgChkBoxForUnassignedDevice(e, { value }, deviceID)} /></List.Description>
                                                                    </List.Content>
                                                                </List.Item>
                                                            )) : <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                                            }
                                                        </List>
                                                    </InfinteScroll>
                                                </div>
                                                :
                                                <div id="unAssignedProjectDeviceScroll"
                                                    style={{
                                                        height: '300px',
                                                        overflow: props?.project?.unAssignedProjectDeviceInfiniteList?.length > 0 ? 'auto' : 'hidden'
                                                    }}
                                                >
                                                    <InfinteScroll
                                                        style={{ height: '100%', overflow: 'initial' }}
                                                        dataLength={props?.project?.unAssignedProjectDeviceInfiniteList?.length}
                                                        hasMore={true}
                                                        next={() => props.fetchNext("UNASSIGN_DEVICE")}
                                                        scrollableTarget="unAssignedProjectDeviceScroll"
                                                    >
                                                        <List selection animated verticalAlign='middle'>
                                                            {props?.project?.unAssignedProjectDeviceInfiniteList?.length > 0 ? props?.project?.unAssignedProjectDeviceInfiniteList?.map(({ deviceEmpID, deviceID, isSelected }) => (
                                                                <List.Item key={deviceID} active={isSelected}>
                                                                    <List.Content textAlign="center">
                                                                        <List.Description className={isSelected ? "listDescriptionBold" : "listDescription"}
                                                                            onClick={() => {
                                                                                props.assignDeviceToProjects({ deviceID: deviceID });
                                                                            }}>{deviceEmpID}</List.Description>
                                                                    </List.Content>
                                                                </List.Item>
                                                            )) : <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                                            }
                                                        </List>
                                                    </InfinteScroll>
                                                </div>
                                            }
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width={2} className="arrowPlacing">
                                <div>
                                    <div className="arrowSpacing">
                                        <Icon name="arrow right" className="arrowWidth" onClick={() => {
                                            props.assignOrUnassignProjectDevices({ isForAssign: true });
                                        }} />
                                    </div>
                                    <div>
                                        <Icon name="arrow left" className="arrowWidth" onClick={() => {
                                            props.assignOrUnassignProjectDevices({ isForAssign: false });
                                        }} />
                                    </div>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={7}>
                                <Header className="headerColor text-color">
                                    Assigned Devices
                                </Header>
                                <Grid.Column className="gridColoumn">
                                    <Search className="searchWidth" onSearchChange={props.onAssignedDeviceSearch} placeholder={Constants.SEARCH_PLACEHOLDER} />
                                </Grid.Column>
                                <Grid celled>
                                    <Grid.Row>
                                        <Grid.Column className="columnHeight stickyData d-flex-imp flex-column-imp">
                                            <Checkbox className="checkbox-override stickyHeader" checked={props.project.isSelectAllAssignedProjectDevice} name='selectAll' label='Select All' onChange={(e, value) => props.handleChkBoxChgForAssignedDevices(e, { value })} />
                                            {props.project.isSelectAllAssignedProjectDevice ?
                                                <div id="AssignedProjectDeviceSelectAll"
                                                    style={{
                                                        height: '300px',
                                                        overflow: props?.project?.assignedProjectDeviceInfiniteList?.length > 0 ? 'auto' : 'hidden'
                                                    }}
                                                >
                                                    <InfinteScroll
                                                        style={{ height: '100%', overflow: 'initial' }}
                                                        dataLength={props?.project?.assignedProjectDeviceInfiniteList?.length}
                                                        hasMore={true}
                                                        next={() => props.fetchNext("ASSIGN_DEVICE")}
                                                        scrollableTarget="AssignedProjectDeviceSelectAll"
                                                    >
                                                        <List selection animated verticalAlign='middle'>
                                                            {props?.project?.assignedProjectDeviceInfiniteList?.length > 0 ? props.project.assignedProjectDeviceInfiniteList.map(({ deviceEmpID, deviceID, isSelected, isCheckedChckBox }) => (
                                                                <List.Item key={deviceID} active={isSelected}>
                                                                    <List.Content textAlign="center">
                                                                        <List.Description className={isSelected ? "listDescriptionBold" : "listDescription"} onClick={() => {
                                                                            props.assignDeviceToProjects({ deviceID: deviceID });
                                                                        }}><Checkbox checked={isCheckedChckBox} label={deviceEmpID} /></List.Description>
                                                                    </List.Content>
                                                                </List.Item>
                                                            )) : <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />}
                                                        </List>
                                                    </InfinteScroll>
                                                </div>
                                                :
                                                <div id="AssignedProjectDevice"
                                                    style={{
                                                        height: '300px',
                                                        overflow: props?.project?.assignedProjectDeviceInfiniteList?.length > 0 ? 'auto' : 'hidden'
                                                    }}
                                                >
                                                    <InfinteScroll
                                                        style={{ height: '100%', overflow: 'initial' }}
                                                        dataLength={props?.project?.assignedProjectDeviceInfiniteList?.length}
                                                        hasMore={true}
                                                        next={() => props.fetchNext("ASSIGN_DEVICE")}
                                                        scrollableTarget="AssignedProjectDevice"
                                                    >
                                                        <List selection animated verticalAlign='middle'>
                                                            {props?.project?.assignedProjectDeviceInfiniteList?.length > 0 ? props.project.assignedProjectDeviceInfiniteList.map(({ deviceEmpID, deviceID, isSelected }) => (
                                                                <List.Item key={deviceID} active={isSelected}>
                                                                    <List.Content textAlign="center">
                                                                        <List.Description className={isSelected ? "listDescriptionBold" : "listDescription"} onClick={() => {
                                                                            props.assignDeviceToProjects({ deviceID: deviceID });
                                                                        }}>{deviceEmpID}</List.Description>
                                                                    </List.Content>
                                                                </List.Item>
                                                            )) : <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />}
                                                        </List>
                                                    </InfinteScroll>
                                                </div>
                                            }
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button primary onClick={() => props.saveAssignOrUnassignProjectDevices({ modalOpen: false })} disabled={props.project.isSaveBtnDisabled}> Save </Button>
                    <Button secondary onClick={() => props.editAssignDevices({ modalOpen: false })}> Back </Button>
                </Modal.Actions>
            </Modal>
            <Modal closeIcon
                open={props.project.isViewProjectDetails}
                closeOnDimmerClick={false}
                onClose={() => props.viewProjectDetail({ modalOpen: false })}>
                <Modal.Header className="headerColor text-color">Project Details</Modal.Header>
                <Modal.Content scrolling>
                    <Form>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <Form.Input
                                    label="Project Name:"
                                    placeholder='Project Name'
                                    value={props.project && props.project.selectedProjects ? props.project.selectedProjects.projectName : ""}
                                    readOnly />
                            </Form.Field>
                            <Form.Field>
                                <Form.Input
                                    label="Project Number:"
                                    placeholder='Project Number'
                                    value={props.project && props.project.selectedProjects ? props.project.selectedProjects.projectNumber : ""}
                                    readOnly />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <Form.Input
                                    label="Division Number:"
                                    placeholder='Division Number'
                                    value={props.project && props.project.selectedProjects ? props.project.selectedProjects.divisionName : ""}
                                    readOnly />
                            </Form.Field>
                            <Form.Field>
                                <Form.Input
                                    label="GC:"
                                    value={props.project && props.project.selectedProjects ? props.project.selectedProjects.gc : ""}
                                    onChange={props.handleGcChange}
                                    maxLength={50}
                                    placeholder="GC"
                                    readOnly={props.user.roleName !== Constants.CONTRIBUTE && props.user.roleName !== Constants.SYSTEM_ADMIN && props.user.roleName !== Constants.ADMIN_ROLE_NAME}
                                />
                            </Form.Field>

                        </Form.Group>
                        <Form.Group inline widths='equal' className="statusTaskCode" >
                            <Form.Field>
                                <List>
                                    <List.Header>
                                        <b>TaskCode:</b>
                                    </List.Header>
                                    <List.Item>
                                        <List.List>
                                            {props.project.selectedProjects && props.project.selectedProjects.taskCode && props.project.selectedProjects.taskCode.length > 0 ? props.project.selectedProjects.taskCode.map(({ taskNumber, taskName }) => (
                                                <p className="taskNumber">{taskNumber}-{taskName}</p>
                                            )) : <NoResultFound displayMessage={"No TaskCode Found"} />}
                                        </List.List>
                                    </List.Item>
                                </List>
                            </Form.Field>
                            <Form.Field>
                                <Form.Select
                                    label='Status'
                                    name='Status'
                                    fluid
                                    value={props.project.selectedProjects && props.project.selectedProjects.projectStatus ? props.project.selectedProjects.projectStatus.toLowerCase() : ""}
                                    options={props.project.projectStatusOptions}
                                    placeholder='Status'
                                    onChange={props.handleFormChange}
                                    disabled={props.user.claimValue.includes(Constants.BUTTON_CLAIMS.PROJECT_STATUS_EDIT_BUTTON) ? false : true} />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                {(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.PROJECT_STATUS_EDIT_BUTTON) || (props.user.roleName === Constants.CONTRIBUTE)) &&
                    <Modal.Actions>
                        <Button primary onClick={props.saveProjectDetails} disabled={props.project.isSaveBtnDisabled} > Save </Button>
                        <Button secondary onClick={() => props.viewProjectDetail({ modalOpen: false })}> Back </Button>
                    </Modal.Actions>}
            </Modal>
            {props.project.filterProjectData && props.project.filterProjectData.length > 0 &&
                < Pagination floated="right"
                    activePage={props.project.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.project.pagination.totalCount} />
            }
        </Layout >
    );
}
export default ProjectsComponent;

ProjectsComponent.displayName = "ProjectsComponent";